import clsx from "clsx";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import CalendarPicker from "../../../components/CalenderPicker";
import Dropdown from "../../../components/Dropdown";
import LeftSide from "../../../components/LeftSide";
import ModalSkeleton from "../../../components/ModalSkeleton";
import NoDataFound from "../../../components/NoDataFound";
import TimePill from "../../../components/TimePill";
import { CorporateIcon, LocationIcon } from "../../../constant";
import { InputSwitch } from "primereact/inputswitch";
import { addMinutes, convertToAmPm } from "../../../helpers";
import BigCalendar from "../../../components/BigCalendar";
import {
  dayOfWeek,
  generateIntervals,
  getCourtTimings,
  getSelectedCourt,
  splitAndMarkBlockedIntervals,
} from "../../../lib";
import { refundAndCancelSchema } from "../../../schema";
import useApi from "../../../useApi";
import classes from "./SlotsTableModal.module.css";
import RescheduleBookingModal from "../ReschduleBooking";

const initialValues = {
  location: null,
  court: null,
  bookingDate: moment().format("YYYY-MM-DD"),
  duration: 60,
  isActive: false,
};
const durations = [
  { label: "1 Hour", value: 60 },
  { label: "30 Minutes", value: 30 },
];
const SlotsTableModal = ({
  show,
  setShow,
  data,
  onSubmit,
  setSelectedTimeSlot,
  setShowAnotherModal,
  newBooking,
  setNewBooking,
}) => {
  const [locationOptions, setLocationOptions] = useState([]);
  const [courtOptions, setCourtOptions] = useState([]);
  const { getAllBlockedSlots } = useApi();
  const [blockedSlots, setBlockedSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [rescheduleData, setRescheduleData] = useState(null);

  const formik = useFormik({
    initialValues,
    validationSchema: refundAndCancelSchema,
    onSubmit: (values, { resetForm }) => {
      console.log("values", values);
      const params = {
        bookingId: data?.bookingId,
        paymentModeId: data?.paymentModeId,
        refundAmount: values?.refundAmount || 0,
        reason: values?.reason,
      };

      if (typeof onSubmit === "function") {
        onSubmit(params);
      }
    },
  });

  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
  } = formik;

  const getAllSlotsApi = async (date, courtId) => {
    setLoading(true);

    const response = await getAllBlockedSlots({
      companyDetailID: 1,
      courtId: courtId,
      date,
    });
    if (response?.data?.headers?.error === 200) {
      console.log("data blocked slots", response?.data?.body?.items);
      setBlockedSlots(response?.data?.body?.items);
      return response?.data?.body?.items;
    }
    if (response?.data?.headers?.error !== 200) {
      toast.error(response?.data?.headers?.message);
    }
  };

  const rescheduleSlot = (data) => {
    console.log("Reschedule data:", data);
    setRescheduleData({
      ...data,
      bookingId: data?.bookingId,
      courtId: data?.courtId,
      locationId: data?.locationId,
      bookingDate: data?.bookingDate,
      courtStartTime: data?.courtStartTime,
      courtEndTime: data?.courtEndTime,
      court: data?.court,
      location: data?.location,
    });
    setShowRescheduleModal(true);
    // setShow(false);
  };

  const handleNewBookingSlot = (data) => {
    setNewBooking(data);
    setShowAnotherModal(true);
    setShow(false);
  };

  useEffect(() => {
    if (data) {
      let locationOptions = data?.locations?.map((data) => ({
        label: data?.locationName,
        value: data?.locationId,
      }));

      setLocationOptions(locationOptions);

      if (locationOptions?.length === 1) {
        setFieldValue("location", locationOptions[0]?.value);
      }
    }
  }, [data]);

  useEffect(() => {
    if (values?.location) {
      let selectLocation = data?.locations?.filter(
        (data) => data?.locationId == values?.location
      );
      if (selectLocation.length > 0) {
        const courtOptions = selectLocation[0]?.courts?.map((data) => ({
          label: data?.courtName,
          value: data?.courtId,
          ...data
        }));

        setCourtOptions(courtOptions);
      }
    }
  }, [values?.location]);
  
  useEffect(() => {
    if (
      values?.location &&
      values?.bookingDate &&
      values?.court &&
      values?.duration
    ) {
      (async () => {
        const allRelatedTiming = getCourtTimings(
          values?.location,
          values?.court,
          dayOfWeek(values?.bookingDate)
        );

        console.log("allRelatedTiming ", allRelatedTiming);
        const blockedAllSlots = await getAllSlotsApi(
          moment(values?.bookingDate)?.format("YYYY-MM-DD"),
          values?.court
        );

        console.log("blockedSlots", blockedAllSlots);

        const allPossibleInterval = generateIntervals(
          allRelatedTiming,
          values?.duration,
          getSelectedCourt(values?.location, values?.court)?.courtSlotDuration
        );

        console.log("allPossibleInterval", allPossibleInterval);

        const splittedResult = splitAndMarkBlockedIntervals(
          allPossibleInterval,
          blockedAllSlots
        );
        console.log("splittedResult", splittedResult);

        const newData = splittedResult?.map((data) => ({
          label: `${convertToAmPm(data?.courtStartTime)} - ${convertToAmPm(
            data?.courtEndTime
          )}`,
          value: `${data?.courtStartTime} - ${data?.courtEndTime}`,
          ...data,
        }));
        console.log(newData, "newData");

        setTimeSlots(newData);
      })();
    }
  }, [values?.bookingDate, values?.location, values?.court, values?.duration]);

  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };


  console.log("values== >",values)
  console.log("selectedTimeSlot", data?.selectedTimeSlot);
  return (
    <>
      <ModalSkeleton
        width="980px"
        show={show}
        setShow={setShow}
        title={"Booking Slots"}
      >
        <form onSubmit={handleSubmit}>
          <Row className={classes.controlGrid}>
          <Col md={3}>
              <CalendarPicker
                isOptional={true}
                // disabled={!values?.court}
                label={"Booking Date"}
                placeholder="Select Booking Date"
                labelStyle={{ fontSize: "16px" }}
                value={values?.bookingDate}
                onChange={(e) => {
                  // Reset time-related fields when date change
                  handleChangeWithTouch("bookingDate")(
                    moment(e).format("YYYY-MM-DD")
                  );
                }}
                errorText={touched?.bookingDate && errors?.bookingDate}
                dateFormat="dd M `y"
              />
            </Col>
            {locationOptions?.length > 1 && (
              <Col md={3}>
                <Dropdown
                  isOptional={true}
                  options={locationOptions}
                  icon={<LeftSide icon={<LocationIcon />} />}
                  customStyle={{ gap: "4px" }}
                  inputStyle={{ paddingLeft: "0" }}
                  labelStyle={{ fontSize: "16px" }}
                  label={"Location"}
                  placeholder="Select Location"
                  value={values?.location}
                  onChange={handleChangeWithTouch("location")}
                  errorText={touched?.location && errors?.location}
                />
              </Col>
            )}
            {values?.isActive && (
              <Col md={3}>
                <Dropdown
                  isOptional={true}
                  options={courtOptions?.filter(court => court?.courtStatusId
                    !== 2)}
                  icon={
                    <LeftSide
                      icon={<CorporateIcon className={classes.icon} />}
                    />
                  }
                  customStyle={{ gap: "4px" }}
                  inputStyle={{ paddingLeft: "0" }}
                  labelStyle={{ fontSize: "16px" }}
                  label={"Court"}
                  placeholder="Select Court"
                  value={values?.court}
                  onChange={handleChangeWithTouch("court")}
                  errorText={touched?.court && errors?.court}
                />
              </Col>
            )}     
             {values?.isActive && (       
                <Col md={3} className={clsx(classes.duration)}>
                  <Dropdown
                    options={durations}
                    isOptional={true}
                    label={"Duration"}
                    placeholder="Select Duration"
                    value={values?.duration}
                    onChange={(e) => {
                      setFieldValue("duration", e);
                    }}
                  />
                </Col>
              )}
            <Col xs={12}>
              <div className={classes.headingAction}>
                <h3 className={classes.title}>Time Slot</h3>
                <span className={classes.toggleContainer}>
                  <p className={classes.toggleLabel}>Switch to Tabular View</p>
                  <InputSwitch
                    checked={values?.isActive}
                    onChange={(e) => setFieldValue("isActive", e.value)}
                    className={classes.switch}
                  />
                </span>
              </div>
              {values?.isActive && (
                <div className={classes.timeGrid}>
                  {timeSlots?.length > 0 ? (
                    timeSlots?.map((data) => (
                      <TimePill
                        key={data?.value}
                        active={data?.label === data?.selectedTimeSlot?.label}
                        data={data}
                        onClick={() => {
                          console.log("data shape", data);
                          setNewBooking(null);
                          setSelectedTimeSlot({
                            ...data,
                            courtId: values?.court,
                            locationId: values?.location,
                            bookingDate: values?.bookingDate,
                            duration: values?.duration,
                            startTime: data?.courtStartTime,
                            endTime: data?.courtEndTime,
                          });
                          setShowAnotherModal(true);
                          setShow(false);
                        }}
                      />
                    ))
                  ) : (
                    <NoDataFound title="No Slots Found" />
                  )}
                </div>
              )}
              {!values?.isActive && (
                <BigCalendar
                  onChange={handleChangeWithTouch("bookingDate")}
                  onReschedule={rescheduleSlot}
                  onNewBooking={handleNewBookingSlot}
                  data={{
                    location: values?.location,
                    courtOptions,
                    bookingDate: values?.bookingDate,
                    locationData: data?.locations,
                  }}
                />
              )}
              {/* <NoDataFound title="No Slots Found" /> */}
            </Col>
          </Row>
        </form>
      </ModalSkeleton>
      {showRescheduleModal && (
        <RescheduleBookingModal
          show={showRescheduleModal}
          setShow={setShowRescheduleModal}
          data={rescheduleData}
          onSubmit={(rescheduleData) => {
            console.log("Reschedule submitted:", rescheduleData);
            setShowRescheduleModal(false);
            setShow(false);
          }}
        />
      )}
    </>
  );
};

export default SlotsTableModal;
